type Props = {
  title: string;
  listElements: string[];
};

const List = ({ title, listElements }: Props) => {
  return (
    <>
      <h4 className="t4 mb-0">{title}</h4>
      <ul className="list-outside list-disc pl-16 mb-0">
        {listElements.map((element) => (
          <li key={element}>{element}</li>
        ))}
      </ul>
    </>
  );
};

export default List;
